import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class CollectionsSearchFormController extends Controller {
  searchCollections = (event) => {
    triggerCustomEvent(events.collections.search_collections, {}, event.target);
  }
}
